angular.module('lsnBase.deprecated.models')
  .factory('ApplicationOperationDataModel', ['LsnApplicationOperationDataModelV1',
    function(LsnApplicationOperationDataModelV1) {
      return LsnApplicationOperationDataModelV1;
    }
  ]);